import { RegistrationTypeModel } from '../../api/models';
import { FieldAlertOnValuesFunction } from '../types';

const notRegisteredWithAsic = (values: Partial<RegistrationTypeModel>) => {
    if (values.organisationIncorporatedType === 'NotIncorporated') {
        return [{
            contentKey: 'NotIncorporatedAdvice',
        }];
    }

    return undefined;
};

export const registrationType: FieldAlertOnValuesFunction<RegistrationTypeModel> = {
    organisationIncorporatedType: notRegisteredWithAsic,
};

export default registrationType;
